import { DateRange } from './time-sheet-summary.request';
import { AdminActivityType } from './admin-activity-summary.request';

export const AdminExportFormat = {
    Csv: 'CSV',
    Pdf: 'PDF',
    Excel: 'EXCEL',
} as const;
export type AdminExportFormat = (typeof AdminExportFormat)[keyof typeof AdminExportFormat];

export interface AdminTimesheetExportRequest {
    dateRange: DateRange;
    format: AdminExportFormat;
    locationId?: number;
    departmentId?: number;
    search?: string;
}

export interface AdminDownloadListExportRequest {
    dateRange: DateRange;
    format: AdminExportFormat;
    locationId?: number;
    departmentId?: number;
    roleId?: number;
    search?: string;
    extraFields?: string[];
}

export interface AdminDownloadEmployeeExportRequest {
    employeeId: number;
    dateRange: DateRange;
    format: AdminExportFormat;
    search?: string;
}

export interface AdminProductivityExportRequest {
    dateRange: DateRange;
    format: AdminExportFormat;
    locationId?: number;
    departmentId?: number;
    employeeId?: number;
    search?: string;
    ignoreHolidays?: boolean;
}

export interface AdminActivityExportRequest {
    type: AdminActivityType;
    dateRange: DateRange;
    format: AdminExportFormat;
    locationId?: number;
    departmentId?: number;
    search?: string;
}
